<template>
  <div
    class="tw-flex tw-w-full tw-items-center tw-justify-between tw-cursor-pointer"
    @click.stop="onSelectOrg"
  >
    <div
      class="tw-flex tw-w-full tw-min-h-[50px] tw-items-center tw-justify-between"
    >
      <div class="tw-flex tw-w-full tw-gap-[15px] tw-items-center">
        <GlobalAvatar
          :name="data.name"
          class-name="!tw-w-[30px] !tw-h-[30px]"
        />
        <span class="tw-truncate org-topic-title">{{ data.name }}</span>
      </div>
      <BButton
        v-if="currentOrg.id !== data.id"
        variant=""
        class="tw-flex tw-items-center tw-w-[121px] tw-max-w-[121px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-px-[13px] tw-py-[10px] tw-rounded-[100px] tw-h-[34px] tw-mr-[50px] hover:tw-bg-[#eff0f1]"
        @click.stop="onSwitchOrg"
      >
        <span class="tw-truncate org-topic-title !tw-text-[11px]">
          {{ getComponentUiText("app-header-menu-search-text-switch-org-1") }}
        </span>
      </BButton>
    </div>
    <IconRight />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import store from "@/store";
import { getComponentUiText } from "@/utils/utilities";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

/** components */
import GlobalAvatar from "@/components/common/globalAvatar.vue";
import IconRight from "@/components/common/globalSearch/menuSearch/iconChevronRight.vue";

const props = defineProps<{
  data: { name: string; id: string };
}>();

const emit = defineEmits<{
  (e: "close-menu"): void;
}>();

const currentOrg = computed<Record<string, any>>(
  () => store.state.Org.currentOrg,
);

const onSwitchOrg = async () => {
  await store.dispatch("Org/switchOrg", { orgId: props.data.id });
  emit("close-menu");
};

const onSelectOrg = () => {
  emit("close-menu");
  EventEmitter.emit(
    EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
    props.data.name,
  );
};
</script>

<style scoped>
.org-topic-title {
  font-family: Poppins, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #387dff;
  user-select: none;
}
</style>
